export class OnlineBooking{
    typeOfApp:number;
    societyNameApp:string;
    address:string;
    regNo:string;
    regValidity:string;
    typeOfBooking:number;
    applicantName:string;
    applicationNo:string;
    applicantAge:number;
    status:number;
	zone:number;
	houseNo:string;
	state:number;
	distict:number;
    city:number;
    pinCode:number;
    emailId:string;
    panCard:string;
    adharCard:string;
    gstin:string;
    mobileNo:number;
    servingEmpOfDDA:number;
    iCardNo:number;
    zoneOfBookingDetail:number;
    locality:number;
    landDesc:number;
    typeOfFunction:number;
    functionName:number;
    category:string;
    categoryType:number;
    areaType:string;
    floorNo:number;
    totalArea:number;
    buildArea:number;
    openArea:number;
    requiredArea:number;
    actualArea:number;	
    groomName:string;
    brideName:string;
    dobFrom:Date;
    dobTo:Date;
    proofOfResident:string;
    ddaIcard:string;
    applicantPhoto:string;
    panCardDoc:string;
    brideAadharCardDoc:string;
    groomAadharCardDoc:string;
    aadharCardDoc:string;
    netAmountPay:number;
	totalBookingAmount:number;
	bookingAmount:number;
	securityDeposit:number;
	cleaningCharges:number;
	cgst:number;
    sgst:number;
    dobOfApplicant:Date;
    relaxationId:string;
    bankAccountNo:string;
    bankName:number;
    ifscCode:string;
    socVerificationCode:string;
    designation:string;
    department:string;
    createdById:number;
    handOverDate:Date;
    handOverTime:string;
    communityHallNo:string;
    createdDate:Date;
    paymentReceipt:string;
    otherActivity:string;
    fileNumber:number;
    governementBody:number;
    governementBodyName:string;
    governementBodyFunName:string;
    anyOther:string;
    bookingAreaType:string;
    functionType1:string;
    functionName1:string;
    relBride:string;
    relGroom:string;
    relBrideProof:string;
    relGroomProof:string;
}